import { defineAsyncComponent } from "vue"
import type { Component } from "vue"
export { CurveType, LegendPosition } from "vue-chrts/enums"

type ChartName = "AreaChart" | "BarChart" | "DonutChart" | "DottedMap" | "LineChart"

function lazyChart(name: ChartName) {
  return defineAsyncComponent(() => import("vue-chrts").then((module) => module[name] as unknown as Component))
}

export const AreaChart = lazyChart("AreaChart")
export const BarChart = lazyChart("BarChart")
export const DonutChart = lazyChart("DonutChart")
export const DottedMap = lazyChart("DottedMap")
export const LineChart = lazyChart("LineChart")
